// =====================================
//
//   Cms 相關功能 Service
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECShared.factory("CMSService", ['$q', '$http', function($q, $http) {

    var factory = {};

    // --------------------------------
    // 取得部落格文章列表
    // --------------------------------
    var getBlogList = function(category, sort, page) {

        var params = {
                op: "getBlogList",
                category: category,
                sort: sort,
                page: page,
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();

        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsBlogAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    if(data && data.results && data.results.length > 0) {
                        for(var i = 0; i < data.results.length; i++) {
                            data.results[i].imageurl = '';
                            if(data.results[i].image) {
                                data.results[i].imageurl = S3_CDN_DOMAIN + data.results[i].image.path + data.results[i].image.filename.replace("/original", "/small") + '?=' + data.results[i].image.size;
                            }
                        }
                    }

                    factory.cmsCache[cachekey] = data;

                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getBlogList request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得部落格文章
    // --------------------------------
    var getBlogPost = function(slug) {

        var params = {
                op: "getBlogPost",
                slug: slug,
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();

        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsBlogAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getBlogPost request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得推薦文章
    // --------------------------------
    var getBlogRecommendPost = function(postid, categories) {

        var defer = $q.defer();
        
        $http({
            url: CMS_URL + "/CmsBlogAction",
            method: "GET",
            params: {
                op: "getBlogRecommendPost",
                postid: postid,
                categories: categories,
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {

                if(data && data.length > 0) {
                    for(var i =0; i < data.length; i++) {
                        data[i].imageurl = '';
                        if(data[i].image) {
                            data[i].imageurl = S3_CDN_DOMAIN + data[i].image.path + data[i].image.filename.replace("/original", "/small") + '?=' + data[i].image.size;
                        }
                    }
                }

                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : CMSService.getBlogRecommendPost request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得部落格分類列表
    // --------------------------------
    var getBlogCategoryList = function() {

        var params = {
                op: "getBlogCategoryList",
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();

        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {        
            $http({
                url: CMS_URL + "/CmsBlogAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getBlogCategoryList request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得部落格分類資訊
    // --------------------------------
    var getBlogCategory = function(category) {

        var params = {
                op: "getBlogCategory",
                category: category,
            },
            cachekey = JSON.stringify(params);
        
        var defer = $q.defer();

        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsBlogAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getBlogCategory request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計師列表
    // --------------------------------
    var getDesignerList = function(category, sort, page) {

        var params = {
                op: "getDesignerList",
                category: category,
                sort: sort,
                page: page,
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();

        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else if(data && data.results) {

                    if(data.results.results && data.results.results.length > 0) {
                        for(var i = 0; i < data.results.results.length; i++) {
                            var item = data.results.results[i];

                            item.imageurl = '';

                            if(item.image) {
                                item.imageurl = S3_CDN_DOMAIN + item.image.path + item.image.filename.replace("/original", "/small") + '?=' + item.image.size;;
                            }

                            item.projects = data.projectMap[item._id];

                            if(item.projects && item.projects.length > 0) {
                                for(var j = 0; j < item.projects.length; j++) {

                                    item.projects[j].imageurl = '';
                                    if(item.projects[j].image) {
                                        item.projects[j].imageurl = S3_CDN_DOMAIN + item.projects[j].image.path + item.projects[j].image.filename.replace("/original", "/small") + '?=' + item.projects[j].image.size;
                                    }
                                }
                            }
                        }
                    }

                    factory.cmsCache[cachekey] = data.results;
                    defer.resolve(factory.cmsCache[cachekey]);
                } else {
                    defer.reject(false);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getDesignerList request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計師資訊
    // --------------------------------
    var getDesigner = function(slug) {

        var params = {
                op: "getDesigner",
                slug: slug,
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();

        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {

                    data.imageurl = '';

                    if(data.image) {
                        data.imageurl = S3_CDN_DOMAIN + data.image.path 
                                                                + data.image.filename.replace("/original", "/small")  + '?=' + data.image.size;
                    }

                    if(data.designerWebsite) {
                        data.designerWebsite = addhttp(data.designerWebsite);
                    }

                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getDesigner request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計師的案例資訊
    // --------------------------------
    var getDesignerProjectPost = function(designerid, page) {

        var params = {
                op: "getDesignerProjectPost",
                designerid: designerid,
                page: page,
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {

                    if(data && data.results && data.results.length > 0) {
                        for(var i =0; i < data.results.length; i++) {
                            data.results[i].imageurl = '';
                            if(data.results[i].image) {
                                data.results[i].imageurl = S3_CDN_DOMAIN + data.results[i].image.path + data.results[i].image.filename.replace("/original", "/small") + '?=' + data.results[i].image.size;
                            }

                            if(data.results[i].designer) {
                                data.results[i].designer.imageurl = '';

                                if(data.results[i].designer.image) {
                                    data.results[i].designer.imageurl = S3_CDN_DOMAIN + data.results[i].designer.image.path 
                                                                            + data.results[i].designer.image.filename.replace("/original", "/small") + '?=' + data.results[i].designer.image.size;
                                }
                            }
                        }
                    }

                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getDesignerProjectPost request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計案例列表
    // --------------------------------
    var getProjectList = function(category, sort, page) {

        var params = {
                op: "getProjectList",
                category: category,
                sort: sort,
                page: page,
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {

                    if(data && data.results && data.results.length > 0) {
                        for(var i = 0; i < data.results.length; i++) {
                            data.results[i].imageurl = '';
                            if(data.results[i].image) {
                                data.results[i].imageurl = S3_CDN_DOMAIN + data.results[i].image.path + data.results[i].image.filename.replace("/original", "/small") + '?=' + data.results[i].image.size;
                            }

                            if(data.results[i].designer) {
                                data.results[i].designer.imageurl = '';

                                if(data.results[i].designer.image) {
                                    data.results[i].designer.imageurl = S3_CDN_DOMAIN + data.results[i].designer.image.path 
                                                                            + data.results[i].designer.image.filename.replace("/original", "/small") + '?=' + data.results[i].designer.image.size;
                                }
                            }
                        }
                    }

                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getProjectList request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計案例總數
    // --------------------------------
    var getProjectPostCount = function() {

        var params = {
                op: "getProjectPostCount",
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getProjectPostCount request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得某位設計師的設計案例總數
    // --------------------------------
    var getProjectPostCountById = function(designerid) {

        var params = {
                op: "getProjectPostCountById",
                designerid: designerid,
            },
            cachekey = JSON.stringify(params);

        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getProjectPostCountById request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計分類列表
    // --------------------------------
    var getDesignCategoryList = function() {

        var params = {
                op: "getDesignCategoryList",
            },
            cachekey = JSON.stringify(params);
        
        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getDesignCategoryList request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計分類資訊
    // --------------------------------
    var getDesignCategory = function(category) {

        var params = {
                op: "getDesignCategory",
                category: category,
            },
            cachekey = JSON.stringify(params);
        
        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: {
                    op: "getDesignCategory",
                    category: category,
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getDesignCategory request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得設計案例內容
    // --------------------------------
    var getProjectPost = function(slug) {

        var params = {
                op: "getProjectPost",
                slug: slug,
            },
            cachekey = JSON.stringify(params);
        
        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsDesignerAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else if(data && data.result) {

                    if(data.designerInfo) {
                        data.designerInfo.imageurl = '';

                        if(data.designerInfo.image) {
                            data.designerInfo.imageurl = S3_CDN_DOMAIN + data.designerInfo.image.path 
                                                             + data.designerInfo.image.filename.replace("/original", "/small") + '?=' + data.designerInfo.image.size;
                        }

                        if(data.designerInfo.designerWebsite) {
                            data.designerInfo.designerWebsite = addhttp(data.designerInfo.designerWebsite);
                        }
                    }

                    data.result.designerInfo = data.designerInfo;
                    factory.cmsCache[cachekey] = data.result;
                    defer.resolve(factory.cmsCache[cachekey]);
                } else {
                    defer.reject(false);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getProjectPost request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得推薦的設計案例
    // --------------------------------
    var getProjcetRecommendPost = function(postid, categories) {

        var defer = $q.defer();
        
        $http({
            url: CMS_URL + "/CmsDesignerAction",
            method: "GET",
            params: {
                op: "getProjcetRecommendPost",
                postid: postid,
                categories: categories,
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {

                if(data && data.length > 0) {
                    for(var i = 0; i < data.length; i++) {
                        data[i].imageurl = '';
                        if(data[i].image) {
                            data[i].imageurl = S3_CDN_DOMAIN + data[i].image.path + data[i].image.filename.replace("/original", "/small") + '?=' + data[i].image.size;
                        }

                        if(data[i].designer) {
                            data[i].designer.imageurl = '';

                            if(data[i].designer.image) {
                                data[i].designer.imageurl = S3_CDN_DOMAIN + data[i].designer.image.path 
                                                                        + data[i].designer.image.filename.replace("/original", "/small") + '?=' + data[i].designer.image.size;
                            }
                        }
                    }
                }

                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : CMSService.getProjcetRecommendPost request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得資源分類資訊
    // --------------------------------
    var getResourceList = function(category, sort, page) {

        var params = {
                op: "getResourceList",
                category: category,
                sort: sort,
                page: page
            },
            cachekey = JSON.stringify(params);
        
        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsResourceAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {

                    if(data && data.results && data.results.length > 0) {
                        for(var i = 0; i < data.results.length; i++) {
                            data.results[i].imageurl = '';
                            if(data.results[i].image) {
                                data.results[i].imageurl = S3_CDN_DOMAIN + data.results[i].image.path + data.results[i].image.filename.replace("/original", "/small") + '?=' + data.results[i].image.size;
                            }

                            if(data.results[i].url) {
                                data.results[i].url = addhttp(data.results[i].url);
                            }
                        }
                    }
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getResourceList request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得資源分類列表
    // --------------------------------
    var getResourceCategoryList = function() {

        var params = {
                op: "getResourceCategoryList",
            },
            cachekey = JSON.stringify(params);
        
        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsResourceAction",
                method: "GET",
                params: {
                    op: "getResourceCategoryList",
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getResourceCategoryList request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 取得資源分類資訊
    // --------------------------------
    var getResourceCategory = function(category) {

        var params = {
                op: "getResourceCategory",
                category: category,
            },
            cachekey = JSON.stringify(params);
        
        var defer = $q.defer();
        
        if(factory.cmsCache[cachekey]) {
            defer.resolve(factory.cmsCache[cachekey]);
        } else {
            $http({
                url: CMS_URL + "/CmsResourceAction",
                method: "GET",
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    factory.cmsCache[cachekey] = data;
                    defer.resolve(factory.cmsCache[cachekey]);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : CMSService.getResourceCategory request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // --------------------------------
    // 增加 Resource view 數量
    // --------------------------------
    var updateResourceViewCount = function(resourceId) {

        var defer = $q.defer();
        
        $http({
            url: CMS_URL + "/CmsResourceAction",
            method: "GET",
            params: {
                op: "updateResourceViewCount",
                resourceId: resourceId,
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : CMSService.updateResourceViewCount request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    /*==========================
        Members
    ==========================*/
    factory.cmsCache = {};

    /*==========================
        Methods
    ==========================*/
    factory.getBlogList = getBlogList; // 取得部落格文章列表
    factory.getBlogPost = getBlogPost; // 取得部落格文章
    factory.getBlogRecommendPost = getBlogRecommendPost; // 取得推薦文章
    factory.getBlogCategoryList = getBlogCategoryList; // 取得部落格分類列表
    factory.getBlogCategory = getBlogCategory; // 取得推薦文章
    factory.getDesignerList = getDesignerList; // 取得設計師列表
    factory.getDesigner = getDesigner; // 取得設計師資訊
    factory.getDesignerProjectPost = getDesignerProjectPost; // 取得設計師的案例資訊
    factory.getProjectList = getProjectList; // 取得設計案例列表
    factory.getProjectPostCount = getProjectPostCount; // 取得設計案例總數
    factory.getProjectPostCountById = getProjectPostCountById; // 取得某位設計師的設計案例總數
    factory.getDesignCategoryList = getDesignCategoryList; // 取得設計分類列表
    factory.getDesignCategory = getDesignCategory; // 取得設計分類資訊
    factory.getProjectPost = getProjectPost; // 取得設計案例內容
    factory.getProjcetRecommendPost = getProjcetRecommendPost; // 取得推薦的設計案例
    factory.getResourceList = getResourceList; // 取得資源分類資訊
    factory.getResourceCategoryList = getResourceCategoryList; // 取得資源分類列表
    factory.getResourceCategory = getResourceCategory; // 取得資源分類資訊
    factory.updateResourceViewCount = updateResourceViewCount; // 增加 Resource view 數量

    return factory;
}]);